export const BETA_CONFIG = {
  // Master toggle - set to false when ready to launch pricing
  isBetaMode: true,

  // All features unlocked during beta
  allFeaturesUnlocked: true,

  // Hide all pricing UI
  showPricing: false,

  // Hide upgrade prompts/modals
  showUpgradePrompts: false,

  // Beta messaging
  betaBadgeText: 'Early Access',
  betaAccessMessage: 'You have full access to all features during the beta period.',

  // Dates
  betaStartDate: '2026-01-01',
} as const;

export type BetaConfig = typeof BETA_CONFIG;
